module.exports = __webpack_public_path__ + "img/pt.e2b367ec.svg";